import React, { Component } from 'react';

import API from '@api';
import postcodeValidation from '@themejs/helpers/postcode';

class RegionSelector extends Component {
  constructor(props) {
    super(props);

    this.containerRef = React.createRef();

    this.state = {
      isOpen: false,
      formMessages: {
        type: null,
        content: null,
      },
      postcodeInput: props.postcode || '',
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside.bind(this));
  }

  componentWillUnmount() {
    document.removeEventListener(
      'mousedown',
      this.handleClickOutside.bind(this),
    );
  }

  handleClickOutside(e) {
    if (
      this.containerRef &&
      this.containerRef.current &&
      !this.containerRef.current.contains(e.target)
    ) {
      this.close();
    }
  }

  handleRegionChange(e) {
    this.props.selectRegion(e.target.value);
  }

  close() {
    this.setState({
      isOpen: false,
    });
  }

  open() {
    if (!this.state.isOpen) {
      this.setState({
        isOpen: true,
      });
    }
  }

  clearFormMessages() {
    this.setState({
      formMessages: {
        type: null,
        content: null,
      },
    });
  }

  checkLocation() {
    if (navigator.geolocation) {
      this.setState({
        formMessages: {
          type: 'info',
          content: 'Loading location information.',
        },
      });

      navigator.geolocation.getCurrentPosition(
        this.handleGeoSuccess.bind(this),
        this.handleGeoError.bind(this),
      );
    }
  }

  handlePostcodeSubmit(e) {
    e.preventDefault();
    const postcode = this.state.postcodeInput;
    if (postcodeValidation(postcode)) {
      this.clearFormMessages();
      API.getNetworkId({
        postcode: postcode,
      })
        .then(networkId => {
          if (networkId) {
            this.props.selectRegion(networkId, postcode);
            this.close();
          } else {
            this.setState({
              formMessages: {
                type: 'error',
                content: 'Invalid postcode',
              },
            });
          }
        })
        .catch(error => {
          console.error(error);
        });
    } else {
      this.setState({
        formMessages: {
          type: 'error',
          content: 'Invalid postcode',
        },
      });
    }
  }

  handleGeoSuccess(e) {
    API.getNetworkId({
      lat: e.coords.latitude,
      lon: e.coords.longitude,
    })
      .then(networkId => {
        this.props.selectRegion(networkId);
        this.clearFormMessages();
        this.close();
      })
      .catch(error => {
        this.setState({
          formMessages: {
            type: 'error',
            content: 'Location not found, please enter a postcode',
          },
        });
      });
  }

  handleGeoError(e) {
    this.setState({
      formMessages: {
        type: 'error',
        content: e.message,
      },
    });
  }

  handlePostcodeInputChange(e) {
    this.setState({
      postcodeInput: e.target.value,
    });
  }

  clearLocation(e) {
    this.setState({
      postcodeInput: '',
    });
    this.props.clearLocation();
  }

  render() {
    return (
      <div
        className="fv-btn tvg-region-selector"
        onClick={this.open.bind(this)}
        ref={this.containerRef}
      >
        <div
          className={`tvg-region-selector__inner ${
            this.state.isOpen ? 'tvg-region-selector__inner--is-open' : ''
          }`}
        >
          <div className="fv-btn tvg-region-selector__cta">
            <span>Regions</span>
            <i className="icon-locate" />
          </div>
          <div className="tvg-region-selector__form">
            <i className="icon-close" onClick={this.close.bind(this)} />
            <h6>We need to know your location</h6>
            <p>
              Knowing where you are is important, so we can display the right
              regional channels in this TV guide.
            </p>
            <form onSubmit={this.handlePostcodeSubmit.bind(this)}>
              <input
                type="text"
                id="postcode"
                name="postcode"
                placeholder="Postcode"
                value={this.state.postcodeInput}
                onChange={this.handlePostcodeInputChange.bind(this)}
              />
              <input
                type="submit"
                className="fv-button fv-button--tertiary"
                value="Set my region"
              />
            </form>
            <p
              className={`tvg-region-selector__form__messages ${
                this.state.formMessages.type
                  ? `tvg-region-selector__form__messages--${this.state.formMessages.type}`
                  : ''
              }`}
            >
              {this.state.formMessages.content}
            </p>

            {!!this.props.postcode && (
              <p className="fv-cta" onClick={this.clearLocation.bind(this)}>
                <i className="icon-locate" />
                <u>Clear my postcode</u>
              </p>
            )}

            {navigator.geolocation && (
              <p className="fv-cta" onClick={this.checkLocation.bind(this)}>
                <i className="icon-locate" />
                <u>Or use my current location</u>
              </p>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default RegionSelector;
